import React from 'react';
import { Col, Row, Stack } from 'react-bootstrap';

import Request from '../utils/Request';
import Skeleton from 'react-loading-skeleton';
import LoadingComponent from '../components/LoadingComponent';
import { AboutType } from '../types/AboutType';

type State = {
  center?: { lat: number; lng: number };
  text?: string;
  about?: AboutType[];
  photo?: string;
};
type Props = {
  loading?: React.RefObject<LoadingComponent | null>;
};

export default class ContactPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { text: undefined, about: undefined, photo: undefined };
  }

  componentDidMount() {
    document.title = (process.env.REACT_APP_NAME ?? 'Kaz Studio') + ' - Contact Page';

    Request.sendRequest('about-list/contact-page').then((result) => {
      const text = result.data.data.content;
      this.setState({ text: text });
      this.props.loading?.current?.closeAnimation();
    });

    Request.sendRequest('about-list').then((result) => {
      const data = result.data.data;
      this.setState({ about: data });
    });

    Request.sendRequest('about-list/contact-page/photo').then((result) => {
      this.setState({ photo: result.data.data.url });
    });
  }

  formatPhoneNumber = (str: string) => {
    //Filter only numbers from the input
    const cleaned = str.replace(/\D/g, '');

    //Check if the input is of correct length
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      return '0' + match[1] + ' ' + match[2] + ' ' + match[3];
    }

    return null;
  };

  render(): JSX.Element {
    return (
      <div className="page contact fade-in-image">
        <Stack className="mt-5 content" direction="horizontal">
          <h3 style={{ fontSize: '3rem' }}>Contact us</h3>
          <div>
            <p className="text pb-5">
              {this.state.text ? (
                <span dangerouslySetInnerHTML={{ __html: this.state.text }}></span>
              ) : (
                <Skeleton baseColor="#707070" highlightColor="#535353" count={2} height={10} />
              )}
            </p>
            <Stack className="contact-options">
              {this.state.about?.map((about) => (
                <div className="field" key={about.key}>
                  <div className="key">{about.key + ':'}</div>
                  <div className="value">
                    {about.type == 'email' && (
                      <a target="_blank" rel="noreferrer" href={'mailto:' + about.value}>
                        {about.value}
                      </a>
                    )}
                    {about.type === 'phone' && (
                      <a target="_blank" rel="noreferrer" href={'tel:+98' + about.value}>
                        {this.formatPhoneNumber(about.value)}
                      </a>
                    )}
                    {about.type == 'text' ? (
                      <>
                        {about.text ? (
                          <a target="_blank" rel="noreferrer" href={about.value}>
                            {about.text.split('\n').map((text) => (
                              <p style={{ marginBottom: '0' }}>{text}</p>
                            ))}
                          </a>
                        ) : (
                          <p className="text">
                            {about.value.split('\n').map((text) => (
                              <p style={{ marginBottom: '0' }}>{text}</p>
                            ))}
                          </p>
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              ))}
            </Stack>
          </div>
          {this.state.photo ? (
            <img
              className="photo"
              src={this.state.photo}
              alt="Contact page"
              style={{ height: '100%' }}
            />
          ) : (
            <Skeleton baseColor="#707070" width={250} highlightColor="#535353" className="h-100" />
          )}
        </Stack>
      </div>
    );
  }
}
